import request from 'utils/request';

export const getBlog = async (blogId) => {
  const { blog } = await request(`api/v1/blogs/${blogId}`);
  return blog;
};

export const getAllBlogs = async () => {
  const { blogs } = await request('api/v1/blogs');
  return blogs;
};
